// couponReducer.js — mirror DealCouponz couponReducer + extra slices for trending / category
import * as couponTypes from "../types/couponTypes";

const initialState = {
  coupons: [],
  coupon: null,
  trendingCoupons: [],
  categoryCoupons: [],
  loading: false,
  error: null,
};

function mergeList(arr, patch) {
  if (!Array.isArray(arr) || !patch?.id) return arr;
  return arr.map((c) => (c.id === patch.id ? { ...c, ...patch } : c));
}

const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case couponTypes.MERGE_COUPON: {
      const patch = action.payload;
      if (!patch?.id) return state;
      return {
        ...state,
        coupon:
          state.coupon && state.coupon.id === patch.id
            ? { ...state.coupon, ...patch }
            : state.coupon,
        coupons: mergeList(state.coupons, patch),
        trendingCoupons: mergeList(state.trendingCoupons, patch),
        categoryCoupons: mergeList(state.categoryCoupons, patch),
      };
    }

    case couponTypes.GET_ALL_COUPONS_REQUEST:
    case couponTypes.GET_COUPON_BY_ID_REQUEST:
      return { ...state, loading: true, error: null, coupon: null };

    case couponTypes.GET_TRENDING_COUPONS_REQUEST:
    case couponTypes.GET_COUPONS_BY_CATEGORY_SLUG_REQUEST:
      return { ...state, loading: true, error: null };

    case couponTypes.GET_ALL_COUPONS_SUCCESS:
      return { ...state, loading: false, coupons: action.payload || [] };

    case couponTypes.GET_COUPON_BY_ID_SUCCESS:
      return { ...state, loading: false, coupon: action.payload };

    case couponTypes.GET_TRENDING_COUPONS_SUCCESS:
      return { ...state, loading: false, trendingCoupons: action.payload || [] };

    case couponTypes.GET_COUPONS_BY_CATEGORY_SLUG_SUCCESS:
      return { ...state, loading: false, categoryCoupons: action.payload || [] };

    case couponTypes.GET_ALL_COUPONS_FAILURE:
    case couponTypes.GET_COUPON_BY_ID_FAILURE:
    case couponTypes.GET_TRENDING_COUPONS_FAILURE:
    case couponTypes.GET_COUPONS_BY_CATEGORY_SLUG_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default couponReducer;
